<template>
  <div class="sf-container">
      <h1>Purchase Subscription</h1>
      <div v-if="step == 'products'">
        Select Products
        <IndividualPurchaseField 
          v-if="mathsAvailable"
          v-model="products"
          class="sf-label-light"
        />
        <div>
          <button @click.prevent="onContinue" class="sf-btn-primary">
            Continue
          </button>
        </div>
      </div>
      <div v-else-if="step == 'confirm'">
        <SagePay
          v-if="purchaseData"
          mode="individual"
          :userId="userId"
          :purchase-data="purchaseData"
        />
      </div>
  </div>
</template>

<script lang="ts">
import IndividualPurchaseField from "@/components/purchase/IndividualPurchaseField.vue";
import SagePay from "@/components/purchase/SagePay.vue";
import apiCall from "@/func/net/apiCall";
import { isMathsAvailable } from "@/state/appState";
import { SfStorePurchaseData, SfSubscriptionKind } from "@/types/generalTypes";
import { defineComponent } from "vue";

export default defineComponent({
  components: { SagePay, IndividualPurchaseField },
  data() {
    return {
      isReady: false,
      products: [] as SfSubscriptionKind[],
      purchaseData: null as SfStorePurchaseData | null,
    };
  },
  computed: {
    step() {
      if(!this.mathsAvailable) {
        return 'confirm';
      }
      return this.$route.params.step || "products";
    },
    mathsAvailable() {
      return isMathsAvailable('individual', 'store');
    },
    userId() {
      return parseInt(this.$route.query.userId as string);
    }
  },
  mounted() {
    this.waitRouter();
  },
  methods: {
    async waitRouter() {
      await this.$router.isReady();
      if (this.$route.query.products) {
        if(Array.isArray(this.$route.query.products)) {
          this.products = this.$route.query.products as SfSubscriptionKind[];
        } else {
          this.products = [this.$route.query.products] as SfSubscriptionKind[];
        }
      }
      if (this.step == "confirm") {
        if(this.products.length < 1) {
          this.$router.replace("/purchase/individual");
        } else {
          this.refreshPurchaseData();
        }
      }
      this.isReady = true;
    },
    async refreshPurchaseData() {
      const params = {
        products: this.products,
      };
      const resData = await apiCall("account/individual-purchase-cost", params);
      if (resData.success) {
        this.purchaseData = resData.data as SfStorePurchaseData;
      }
    },
    onContinue() {
      if(this.products.length < 1) {
        return;
      }
      const query = { products: this.products };
      this.$router.push({ path: "/purchase/individual/confirm", query });
      this.refreshPurchaseData();
    }
  },
});
</script>
